import React from "react";
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";
import {auth} from "../../firebase";
import {MissingType} from "../../db/models/extra";
import firebase from "firebase/compat/app";
import {Logout} from "../../api/auth";
import {closeDialog, openDialog} from "../../slices/dialog";
import {sendEmailVerification} from "../../helpers/auth";
import {DialogMessage} from "./DialogMessage";
import {openAlert} from "../../slices/alert";
import {useTranslation} from "react-i18next";
import {updateUser} from "../../api/user";

const ChangeEmail = () => {
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            email: "",
            password: "",
            newEmail: "",
        },
    });
    const dispatch = useDispatch();
    const account = auth.currentUser;
    const {t} = useTranslation();

    const onSave = async (form: MissingType) => {
        try {
            if (!account) return;

            const credential = firebase.auth.EmailAuthProvider.credential(
                form.email,
                form.password
            );
            await account.reauthenticateWithCredential(credential);
            await account.updateEmail(form.newEmail);

            await updateUser({email: form.newEmail});

            dispatch(closeDialog());

            await sendEmailVerification();
            await Logout(dispatch);
            dispatch(
                openDialog({
                    Content: DialogMessage,
                    title: t("student_dialogMsg_changeEmail_title"),
                    props: {
                        text: t("student_dialogMsg_changeEmail_text"),
                    },
                    closable: true,
                })
            );
        } catch (error) {
            console.error(error);
            dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("account_changeEmail_currEmail_label")}</div>
                    <input type="email" name="email" ref={register({required: true})}/>
                    {errors.email && <p>{t("account_changeEmail_currEmail_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("account_changeEmail_currPsw_label")}</div>
                    <input
                        type="password"
                        name="password"
                        ref={register({required: true})}
                    />
                    {errors.password && <p>{t("account_changeEmail_currPsw_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("account_changeEmail_newEmail_label")}</div>
                    <input
                        type="email"
                        name="newEmail"
                        ref={register({required: true})}
                    />
                    {errors.newEmail && <p>{t("account_changeEmail_newEmail_error")}</p>}
                </div>
                <input type="submit" value={t("account_changeEmail_submit") as string}/>
            </form>
        </div>
    );
};

export default ChangeEmail;
